<template>
    <div class="howto">
        <h2 class="title is-3">エモーションダイアリーの使い方</h2>
        <h3 class="title is-4" style="color:#50BD8A;">ステップ１：ユーザー登録しよう！</h3>
        <p>画面右上のログインボタンを押してログイン画面にいきます。</p>
        <img src="@/assets/login_view.jpeg">
        <p>メールアドレスとニックネームを入力して登録完了です。</p>
        <img src="@/assets/login_view2.jpeg">
        <h3 class="title is-4" style="color:#50BD8A;">ステップ２：日記を書こう</h3>
        <p>エモーションダイアリーはとてもシンプル！あとはホーム画面で日記を書きましょう！</p>
        <img src="@/assets/login_view3.png">
        <div v-if="!userStatus" class="login">
            <router-link to="login"><i class="fas fa-sign-in-alt"></i> 登録して始める！</router-link> 
        </div>
    </div>
</template>

<script>
export default {
    computed: {
        userStatus() {
            return this.$store.getters.isSignIn;
        }
    },
    mounted(){
        const title = "使い方｜エモーションダイアリー"
        const description = "エモーションダイアリーのログイン方法、サービスの使い方を解説します。"
        document.title = title
        document.querySelector("meta[property='og:title']").setAttribute('content', title)
        document.querySelector("meta[name='description']").setAttribute('content', description)
        document.querySelector("meta[property='og:description']").setAttribute('content', description)
    }
}
</script>


<style scoped>
.howto{
    max-width: 800px;
    margin:auto;
    padding: 10px;
    margin-top: 40px;
    font-weight: bold;
    font-size:1.1em;
}
p{
    padding:10px;
}
.login{
    margin:50px;
}
</style>